import { timePeriodsFactory } from './categories';

const getRaceType = val => val.match(/jumps|flat/)[0];

const timePeriodReducer = (timePeriod, action) => {
    const { raceType, seasonsAvailable, country } = timePeriod.createdBy;
    if (action.type === 'raceType') {
        const newRaceType = getRaceType(action.value);
        if (raceType !== newRaceType) {
            return timePeriodsFactory(
                country,
                newRaceType,
                seasonsAvailable
            );
        }
    }
    return timePeriod;
};

const categoriesReducer = (categories, action) => ({
    ...categories,
    timePeriod: timePeriodReducer(categories.timePeriod, action),
});


export default categoriesReducer;



// WEBPACK FOOTER //
// ./src/js/course/stats/reducer.js